import { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { API_NO_AUTH } from "../../utils/api";
import { setToken } from "../../utils/api";
import { getErrorsStatus422 } from "../../utils/errorsHandling";
import ToastMessageContext from "../../context/ToastMessageContext";
import FormErrorMessage from "../Utils/FormErrorMessage";
import MoreFormErrors from "../Utils/MoreFormErrors";
import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import { Button } from "primereact/button";
import AuthContext from "../../context/AuthContext";
import useForm from "../../hooks/useForm";

/** STATIC VALUES */
const initialValues = {
  email: "",
  password: "",
};

const initialFormErrors = {
  email: null,
  password: null,
};
/** END STATIC VALUES */

export default function LoginForm() {

  /** CUSTOM FORM HOOK */
  const {
    handleFormChange,
    formData,
    formErrors,
    setFormErrors,
    moreFormErrors,
    setMoreFormErrors
  } = useForm(initialValues, initialFormErrors);

  const navigate = useNavigate();

  const { showError } = useContext(ToastMessageContext);
  const { updateUserData } = useContext(AuthContext);
  const [loadingForm, setLoadingForm] = useState(false);

  const validateForm = () => {
    let formIsValid = true;
    let _formErrors = formErrors;
    if (formData.email === "") {
      formIsValid = false;
      _formErrors = {
        ..._formErrors,
        email: "Campo requerido",
      };
    }

    if (formData.password === "") {
      formIsValid = false;
      _formErrors = {
        ..._formErrors,
        password: "Campo requerido",
      };
    }

    setFormErrors(_formErrors);
    return formIsValid;
  };

  /** ----QUERYS---- */
  const loginQuery = () => {
    setLoadingForm(true);
    API_NO_AUTH.post("auth/login", formData)
      .then((res) => {
        updateUserData(res.data.user);
        setToken(res.data.access_token);
        navigate("/");
      })
      .catch((err) => {
        const errors = err.response;
        if (errors.status === 401) {
          setMoreFormErrors(["Usuario y/o contraseña incorrectos."]);
        } else if (errors.status === 422) {
          const errors422 = getErrorsStatus422(errors.data.errors);
          setMoreFormErrors(errors422);
        } else {
          showError(err.message);
        }
      })
      .then(() => {
        setLoadingForm(false);
      });
  };
  /** ----END QUERYS---- */

  const login = (event) => {
    event.preventDefault();
    if (validateForm()) {
      loginQuery();
    }
  };

  return (
    <form className="p-fluid grid" autoComplete="off" onSubmit={login}>
      <div className="field col-12 mt-4">
        <span className="p-float-label">
          <InputText
            className={`w-full ${formErrors.email && "p-invalid"}`}
            name="email"
            value={formData.email}
            onChange={handleFormChange}
          />
          <label>Email</label>
        </span>
        <FormErrorMessage inputName="email" formErrors={formErrors} />
      </div>

      <div className="field col-12 mt-4">
        <span className="p-float-label">
          <Password
            className={`w-full ${formErrors.password && "p-invalid"}`}
            name="password"
            value={formData.password}
            onChange={handleFormChange}
            toggleMask
            feedback={false}
          />
          <label>Contraseña</label>
        </span>
        <FormErrorMessage inputName="password" formErrors={formErrors} />
      </div>

      <MoreFormErrors errors={moreFormErrors} />

      <div className="field p-2 mt-4 w-full">
        <Button
          type="submit"
          loading={loadingForm}
          label="Iniciar Sesion"
          icon="pi pi-user"
          className="w-full"
        />
      </div>
    </form>
  );
}
